const AppSettingModule = {
  namespaced: true,
  state: () => ({
    language: 'th',
    locale: 'th-TH'
  }),
  actions: {},
  getters: {
    getLocale: state => state.locale,
    getLanguage: state => state.language,
  },
  mutations: {
    setLocale: (state, locale) => {
      state.locale = locale;
      if (locale == 'th-TH')
        state.language = 'th'
      else if (locale == 'en-US')
        state.language = 'en'
      else if (locale == 'lo-LA')
        state.language = 'lo'
    },
    setLanguage: (state, language) => {
      state.language = language;
      if (language == 'th')
        state.locale = 'th-TH'
      else if (language == 'en')
        state.locale = 'en-US'
      else if (language == 'lo')
        state.locale = 'lo-LA'
    },
  },
};
export default AppSettingModule;
